import { createApp } from 'vue';
import DownloadModal from "./DownloadModal.vue";


const downloadModalEl = document.getElementById('download_modal');

if (downloadModalEl) {
  const app = createApp(DownloadModal);
  const vm = app.mount('#download_modal');
}
